<template>
     <div class="wrapper-overlay open-overlay ">
            <div class="header-overlay header-overlay-svg">
                <a :href="homepageRedirection">
                    <img v-on:click="window.location.href= homepageRedirection"  src="/ext_files/prepaid/f2g/images/logotype_dark.svg">
                </a>
                 <a :href="closeModalRedirection">
                    <svg  v-on:click="window.location.href= closeModalRedirection" class="close-overlay" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">                       
                        <desc>Created with Sketch.</desc>
                        <g id="Icon/Menu/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M4.38605846,25.6177075 C4.64303181,25.8725692 4.97774286,26 5.31247602,26 C5.6471926,26 5.98188707,25.8725692 6.23889359,25.6177075 L15,16.8528625 L23.7633218,25.6177075 C24.0202952,25.8725692 24.3528502,26 24.6897394,26 C25.024456,26 25.3591505,25.8725692 25.616157,25.6177075 C26.1279477,25.1058277 26.1279477,24.2764407 25.616157,23.7645498 L16.8528372,15.0019165 L25.6139457,6.23707158 C26.1257364,5.72519181 26.1257364,4.89580481 25.6139457,4.38391398 C25.102155,3.87202315 24.2729123,3.8720342 23.7611106,4.38391398 L15,13.1487589 L6.2366823,4.38612565 C5.7248916,3.87424587 4.89564893,3.87424587 4.38384717,4.38612565 C3.87204541,4.89800542 3.87205647,5.72739242 4.38384717,6.23928325 L13.1471669,15.0019165 L4.38605846,23.7667615 C3.87426776,24.2786413 3.87426776,25.1058719 4.38605846,25.6177627 L4.38605846,25.6177075 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
                        </g>
                    </svg>
                 </a>
            </div>
         <div class="container-overlay overlay-form">
           <div class="overlay-message">
                <img src="/ext_files/prepaid/f2g/images/error@2x.png" class="logo-overlay" />
                <div class="title-overlay1">
                    {{content["myf2g.topuperror.title"]}}
                </div>
                <div class="title-overlay2">
                    <p v-if="errorFromBank">{{content["myf2g.topuperror.bankmessage"]}}</p>
                    <p v-else-if="faultDescription === 'The requested MSISDN is blacklisted'">{{ forcePersonalDataErrorMessage }}</p>
                    <p v-else>{{content["myf2g.topuperror.message1"]}}</p>
                    <p v-if="faultDescription === 'Black'">{{content["myf2g.topuperror.message2"]}}</p>
                    <p v-else-if="faultDescription === 'transactionsCounterlast24hours'">{{content["myf2g.topuperror.message3"]}}</p>
                    <p v-else-if="faultDescription === 'amountCounterlast24hours'">{{content["myf2g.topuperror.message4"]}}</p>
                    <p v-else-if="faultDescription === 'amountCounterlast30days'">{{content["myf2g.topuperror.message5"]}}</p>
                    <p v-else-if="faultDescription === 'transactionsCounterlast30days'">{{content["myf2g.topuperror.message6"]}}</p>
                    <p v-else-if="!getActiveFlow">{{content["myf2g.topuperror.message7"]}}</p>
                </div>
                 
           </div>             
         </div>
      </div>
</template>


<script>
export default {
    name: "ErrorComponent",
    data: function() {
      return {
        content: '',
      };
    },
    created(){
        let self = this;

        /************************
         *** WCS service call ***
         ************************/

        let configWCS = {
        sessionKey: "wcs_topup_error",
        axiosConfig: {
        method: "get",
            url: '/gr/f2g/vueContentService/',
            params: {
                ciKey: 'myf2gtopuperror',
                locale: self.locale
            }
        }
        }

        this.fetchDataFromWCS(configWCS)
            .then(response => {
            console.log(JSON.stringify(response))
            self.content = response
            })
            .catch(error => {
            console.log(error);
            })
            .finally(() => {
            console.log("finally");
            });

        document.body.classList.add("opened-overlay");
        this.clearSessionStorage();
    },
    computed:{
        locale() {
            return this.$store.state.locale;
        },
        faultDescription(){
            return this.$store.state.faultDescription;
        },
        getActiveFlow(){
            return this.$store.state.activeFlow;
        },
        closeModalRedirection(){
            if (this.locale == 'en_US') {
                return '/en/myf2g/'
            } else {
                return '/gr/myf2g/'
            }
        },
        homepageRedirection() {
            if (this.locale == 'en_US') {
                return '/en/f2g/'
            } else {
                return '/gr/f2g/'
            }
        },
        errorFromBank(){
            return this.$store.state.errorFromBank;
        },
        forcePersonalDataErrorMessage() {
            return this.$store.state.forcePersonalDataErrorMessage;
        }
    },
    methods:{
        clearSessionStorage(){
            var serviceNames = ["getUserProfileAndTariffs_", "getPaypalToken_", "getCardAndRecurringInfo_",  "activeFlow_", "currentStep", "token", "email", "msisdn"];
            for(var item = 0; item < serviceNames.length; item++){
                var i, results = [];
                var query = serviceNames[item];

                for (i in sessionStorage) {
                    if ( Object.prototype.hasOwnProperty.call(sessionStorage, i)) {
                        if (i.match(query) || (!query && typeof i === 'string')) {
                            results.push({key:i});
                        }
                    }
                }
                for(var x = 0; x < results.length; x++){
                sessionStorage.removeItem(results[x].key);
                }
            }
        },
    },
    destroyed(){
        document.body.classList.remove("opened-overlay");
    },
};

</script>